import { getAckDoc, getAckDocStatus } from 'services/axios/media'

export const actions = {
  GET_ACKNOWLEDGEMENT_DOCUMENT: 'GET_ACKNOWLEDGEMENT_DOCUMENT',
  GET_AGENT_DOC_STATUS: 'GET_AGENT_DOC_STATUS',
  HANDLE_PAGINATION: 'HANDLE_PAGINATION',
  HANDLE_AGENT_DOC_VIEW_PAGINATION: 'HANDLE_AGENT_DOC_VIEW_PAGINATION',
}

export const getAcknowledgementDocuments = ({ skip, limit, ackStatus }) => {
  return async (dispatch) => {
    const response = await getAckDoc({ skip, limit, ackStatus })
    dispatch({
      type: actions.GET_ACKNOWLEDGEMENT_DOCUMENT,
      payload: {
        documentList: response?.data?.data,
        totalCount: response?.data?.data?.totalCount,
      },
    })
  }
}

export const getAckStatus = ({ skip, limit }, id, filter) => {
  return async (dispatch) => {
    const response = await getAckDocStatus({ skip, limit }, id, filter)
    dispatch({
      type: actions.GET_AGENT_DOC_STATUS,
      payload: {
        documentList: response?.data?.data?.documentList,
        totalCount: response?.data?.data?.totalCount,
      },
      // payload: response?.data?.data,
    })
  }
}

export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAGINATION',
    payload: pagination,
  }
}

export const handleAgentDocStatusPagination = (pagination) => {
  return {
    type: actions.HANDLE_AGENT_DOC_VIEW_PAGINATION,
    payload: pagination,
  }
}
